import { BKJStickyTableHead } from 'components/BKJTable/BKJTable.styled';
import { BKJTableSubHeader } from 'components/BKJTable/BKJTableSubHeader';
import { useTranslation } from 'hooks/useTranslation';

import { Fragment } from 'react';

export function UnSuccessTeamMemberTableHeader() {
  const { t } = useTranslation();
  return (
    <Fragment>
      <BKJStickyTableHead>
        <BKJTableSubHeader name="error" title={t('team_member:ERROR')} direction="default" />
      </BKJStickyTableHead>
      <BKJStickyTableHead>
        <BKJTableSubHeader name="column" title={t('team_member:COLUMN')} direction="default" />
      </BKJStickyTableHead>
      <BKJStickyTableHead>
        <BKJTableSubHeader name="row" title={t('team_member:ROW')} direction="default" />
      </BKJStickyTableHead>
    </Fragment>
  );
}
